import { computed as u, Comment as n, Text as f, Fragment as i } from "vue";
function e(t) {
  return t.every((r) => !!(r.type === n || r.type === f && !r.children.trim() || r.type === i && e(r.children)));
}
const m = (t) => t ? typeof t != "function" ? !1 : e(t()) : !0;
function s({ slot: t }) {
  return {
    slotIsEmpty: u(() => m(t))
  };
}
export {
  s as default,
  m as isEmpty
};
